import React, { forwardRef } from 'react';
import { css, cx } from '@emotion/css';

interface SectionCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const sectionCard = css({
  width: '100%',
  maxWidth: '1440px',
  padding: 'var(--spacing-xl) var(--spacing-md)',
  backgroundColor: 'var(--primary-color)',
  borderRadius: 'var(--spacing-md)',
  border: '1px solid rgba(var(--pcrgba-200), 0.5)',
  boxShadow: 'var(--home-shadow)',
  position: 'relative',
  overflow: 'hidden',
  '@media (max-width: 1440px)': {
    padding: 'var(--spacing-lg) 0 var(--spacing-md) var(--spacing-lg)',
  },
  '@media (max-width: 768px)': {
    padding: 'var(--spacing-md) 0',
  },
});

export const SectionCard = forwardRef<HTMLDivElement, SectionCardProps>(
  ({ children, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cx(sectionCard, className)}
        style={style}
        {...props}
      >
        {children}
      </div>
    );
  }
);

SectionCard.displayName = 'SectionCard';

export default SectionCard;
